import { useSupportedBookingSoftware, useTruelarkDependency } from '@frontend/api-ai-settings';
import { useAppScopeStore } from '@frontend/scope';
import { useAiReceptionistAccess } from './use-ai-receptionist-access';

export const useAiScheduleAccess = () => {
  const { selectedLocationIds, selectedOrgId } = useAppScopeStore();
  const { hasAiReceptionistAccess } = useAiReceptionistAccess();

  const { meetsTruelarkDependency, isLoading: isTruelarkDependencyLoading } = useTruelarkDependency({
    locationIds: selectedLocationIds,
    orgId: selectedOrgId,
  });

  const { hasSupportedBookingSoftware, isLoading: isBookingSoftwareLoading } = useSupportedBookingSoftware({
    locationIds: selectedLocationIds,
    orgId: selectedOrgId,
    isEnabled: meetsTruelarkDependency,
  });

  const hasAiScheduleAccess = hasAiReceptionistAccess && hasSupportedBookingSoftware;

  const canUseAiScheduleFeatures = hasAiScheduleAccess && meetsTruelarkDependency;

  return {
    hasAiScheduleAccess,
    canUseAiScheduleFeatures,
    hasAiReceptionistAccess,
    hasSupportedBookingSoftware,
    meetsTruelarkDependency,
    isLoading: isTruelarkDependencyLoading || isBookingSoftwareLoading,
  };
};
